<script setup>
  import { computed, useTemplateRef } from 'vue';
  import { useTidesStore } from "@/stores/TidesStore";
  import TideSpotEvent from '@/components/TideSpotEvent.vue';
  import { useResizeObserver } from '@vueuse/core'

  const tidesStore = useTidesStore();

  const eventsContainer = useTemplateRef('events-container');

  const emits = defineEmits(['change:containerHeight']);
  const containerHeight = defineModel('containerHeight', { type: Number, default: 0 });

  const tideEventsByColumn = computed(() => {
    const tideEvents = [...tidesStore.tideEvents];
    if (tideEvents.length <= 5) {
      return [tideEvents, null];
    }

    const firstColumnAdditionalEventCount = tideEvents.length % 2;
    const secondColumnEventCount = (tideEvents.length - firstColumnAdditionalEventCount) / 2;
    const firstColumnEventCount = secondColumnEventCount + firstColumnAdditionalEventCount;

    return [
      [...tideEvents].slice(0, firstColumnEventCount),
      [...tideEvents].slice(firstColumnEventCount)
    ];
  });  

  useResizeObserver(eventsContainer, (entries) => {
    const entry = entries[0]
    const { height } = entry.contentRect
    if (height !== containerHeight.value) emits('change:containerHeight', height);
    containerHeight.value = height;
  })  
</script>

<template>
  <div ref="events-container" class="jwx-tide-spot__event-group" data-content="events" :data-column-count="tideEventsByColumn.length">
    <div class="jwx-tide-spot__event-list-container">
      <div class="jwx-tide-spot__event-list">
        <TideSpotEvent
          v-for="event in tideEventsByColumn[0]" 
          :key="event.dateTime"
          :event="event"
        ></TideSpotEvent>
      </div>
      
      <div
        v-if="tideEventsByColumn[1]"
        class="jwx-tide-spot__event-list"
      >
        <TideSpotEvent
          v-for="event in tideEventsByColumn[1]" 
          :key="event.dateTime"
          :event="event"
        ></TideSpotEvent>
      </div>
    </div>
  </div>
</template>